import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {  observable, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

//import { HttpHeaders} from '@angular/common/http';
// import { QuestionModel } from './question';
// import { ReviewModel } from './review';
 import { TrainingDetails } from '../models/training-details';
import { MainpowerDetails } from '@/models/manpower-details';


 

@Injectable({
  providedIn: 'root'
})
export class FswService {
 
  private apiURL = environment.apiURL;
    
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  httpOptions1 = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'vendor-access-token' :'d23c8c5be7d7f101c9b927ed5381dbf8'

    })
  }
   
  constructor(private httpClient: HttpClient) { }
    
  getTrainingListByUser(userId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTrainingList/'+userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getTrainingList(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllTraining')
    .pipe(
      catchError(this.errorHandler)
    )
  }

   getTrainingListDash(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllTrainingCount')
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getTestingList(userId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingList/'+userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  // getTestingList(): Observable<any[]> {
  //   return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllTestings')
  //   .pipe(
  //     catchError(this.errorHandler)
  //   )
  // }

  getSampleList(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllTestings')
    .pipe(
      catchError(this.errorHandler)
    )
  }

    getSampleListDash(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllTestingsCount')
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getSampleListByUser(userId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getSampleDetails/'+userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getSampleDetails(sampleId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingDetailBySampleId/'+sampleId)
    .pipe(
      catchError(this.errorHandler) 
    )
  }
  getOtherSampleDetails(sampleId: String):Observable<any[]>
  {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingDetails_Other/'+sampleId)
    .pipe(
      catchError(this.errorHandler) 
    )
  }

  getUserDetails(userId:String): Observable<any[]> {
    return this.httpClient.get<any>(this.apiURL + '/users/getUserDetails/'+userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
    
  saveTrainingData(formData:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/insertUpdateTrainingData', formData)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  saveTestingData(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveTestingDetails', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  
  saveNewProduct(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/addProduct', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  saveProductVsParameter(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/addTestParameters', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  generateSampleId(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/addSamples', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
    
    
  getProducts(){
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getProducts')
    .pipe(
      catchError(this.errorHandler)
    )

   // return of([{product_name:"Milk", product_id:1},{product_name:"Water", product_id:2}])

  }

  getProductVsParameters(productId:any):Observable<any[]>{
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getParameters/' + productId)
    .pipe(
      catchError(this.errorHandler)
    )
    //const data = [{id:1, product_name:"Milk", product_id:1, parameter_name:"Fat"},{id:2, product_name:"Milk", product_id:1, parameter_name:"Protien"}]
    //return of(data)

  }

  getVehicleDetail(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/users/getAllVehicle', this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
    
  getState(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getStates', this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  addVehicle(data: any[]): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/users/signup', JSON.stringify(data), this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  } 
  saveTrainingFile(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveTrainingFileUploads', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getTrainingFile(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTrainingFileUploads', this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  updateTrainingData(id:any, formData:any) {
    return this.httpClient.put<any>(this.apiURL + '/fsw/updateTrainingDetails/' + id, formData)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  saveawpFile(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveAwpFileUploads', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getawpFile(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAwpFileUploads', this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  saveawpData(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveAwarenessProgramData', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  updateawpData(id:any, formData:any) {
    return this.httpClient.put<any>(this.apiURL + '/fsw/updateAwarenessProgramDetails/' + id, formData)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  savetestFile(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveTestingFileUploads', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  gettestFile(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingFileUploads', this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getFilesByTestId(testId:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingFileUploadsWithTestId/'+ testId, this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  updatetestData(id:any, data:any) {
    return this.httpClient.put<any>(this.apiURL + '/fsw/updateTestingDetails/' + id, data, this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getTrainingFiles(Id: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTrainingFileUploadsWithTrainingId/'+Id)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  saveTestingDetails_Other(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveTestingDetails_Other', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getTestingDetails_Other(sampleId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingFileUploadsWithTestId/'+sampleId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getAwsList(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllAwarenessProgramDetails')
    .pipe(
      catchError(this.errorHandler)
    )
  } 
  getAwsListDash(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllAwarenessProgramDetailsCount')
    .pipe(
      catchError(this.errorHandler)
    )
  } 
  getAwsListByUser(userId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAwarnessProgramDetails/'+userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getTestingFileUploadsWithTestId(testId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingFileUploadsWithTestId/'+testId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getTrainingFileUploadsWithTrainingId(trainingId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTrainingFileUploadsWithTrainingId/'+trainingId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getAwpFileUploadsWithAwpId(awpId: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAwpFileUploadsWithAwpId/'+awpId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  deleteTrainingFileUploadsWithTrainingId(TrainingId:any){
    return this.httpClient.delete<TrainingDetails>(this.apiURL + '/fsw/deleteTrainingFileUploadsWithTrainingId/' + TrainingId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  
  deleteAwpFileUploadsWithAwpId(AwpId:any){
    return this.httpClient.delete<TrainingDetails>(this.apiURL + '/fsw/deleteAwpFileUploadsWithAwpId/' + AwpId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  deleteProduct(productId)
  {
    return this.httpClient.delete<TrainingDetails>(this.apiURL + '/fsw/deleteProduct/' + productId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  deleteParameter(productId,test_param_id)
  {
    return this.httpClient.delete<TrainingDetails>(this.apiURL + '/fsw/deleteParameter/' + productId+'/'+ test_param_id)
    .pipe(
      catchError(this.errorHandler)
    )
  }


deleteTestingFileUploadsWithTestId(testId:any){
  return this.httpClient.delete<TrainingDetails>(this.apiURL + '/fsw/deleteTestingFileUploadsWithTestId/' + testId)
  .pipe(
    catchError(this.errorHandler)
  )
}

  deleteNodelOfficer(id)
  {
    return this.httpClient.delete<any>(this.apiURL + '/users/deleteNodalOfficer/' + id)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  updateProfileData(id:any, formData:any) {
    return this.httpClient.put<any>(this.apiURL + '/fsw/updateUserDetails/' + id, formData)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  addUser(data: any[]): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/users/addUser', JSON.stringify(data), this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getUsersDetail(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/users/getAllUsers', this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  checkOtp(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/users/validateOtp', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  updatePassword(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/users/updatepassword', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getTrainingListByState(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTrainingListByState/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getTrainingListByStateVehicleNo(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTrainingListByStateVehicleNo/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getTrainingListCount(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/stateWiseTrainingCount/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getTestingListByState(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingListByState/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }


  getTestingListByStateVehicleNo(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getTestingListByStateVehicleNo/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getTestingListCount(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/stateWiseTestingCount/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getVehicleListByState(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/users/getAllVehicleswithState/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getVehicleListCount(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/stateWiseVehicleCount/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getawpListByState(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAwarenessProgramListByState/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getawpListByStateVehicleNo(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAwarenessProgramListByStateVehicleNo/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getawpListCount(stateCode: String): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/stateWiseAwpCount/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  getVehicleByRegion(regionCode:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllVehicleByRegion/'+regionCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getTrainingByRegion(regionCode:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllTrainingByRegion/'+regionCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getTestingByRegion(regionCode:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllTestingByRegion/'+regionCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getAWPByRegion(regionCode:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllAwpByRegion/'+regionCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getRegion(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/users/getAllRegions', this.httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  deleteVehicle(formData:any) {
    debugger
    return this.httpClient.post<any[]>(this.apiURL + '/users/deleteVehicle', formData)
    .pipe(
      catchError(this.errorHandler)
    ) 
  }
  
  deleteTraining(formData:any) {
    debugger
    return this.httpClient.post<any>(this.apiURL + '/fsw/deleteTrainingDetails', formData)
    .pipe(
      catchError(this.errorHandler)
    ) 
  }
  deleteTesting(formData:any) {
    debugger
    return this.httpClient.post<any>(this.apiURL + '/fsw/deleteTestingDetails',formData)
    .pipe(
      catchError(this.errorHandler)
    ) 
  }

  actionTakenTesting(formData:any) {
    debugger
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveActionTaken',formData)
    .pipe(
      catchError(this.errorHandler)
    ) 
  }
 
  deleteAwarenessProgram(formData:any) {
    debugger
    return this.httpClient.post<any>(this.apiURL + '/fsw/deleteAwarenessDetails', formData)
    .pipe(
      catchError(this.errorHandler)
    ) 
  }
  getDistrict(stateCode:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getDistrict/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  // getMonthWiseTestingStatus(): Observable<any[]> {
  //   return this.httpClient.get<any[]>(this.apiURL + '/fsw/getMonthWiseTestingStatus')
  //   .pipe(
  //     catchError(this.errorHandler)
  //   )
  // }
  getActivityDetails(activity) :Observable<any[]> 
  { 
    let backendUrlPart='';
    if(activity=='Testing')
    backendUrlPart='/fsw/getMonthWiseTestingStatus';
    else if(activity=='Trainings')
    backendUrlPart='/fsw/getMonthWiseTrainingStatus';
    else if(activity=='Awareness Programs')
     backendUrlPart='/fsw/getMonthWiseAwarenessProgramStatus';
    else if(activity=='Vehicle')
    backendUrlPart='/fsw/getMonthWiseVehicalStatus';
   
    return this.httpClient.get<any[]>(this.apiURL + backendUrlPart)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getActivityDetailsByNodelOfficer(activity,stateCode):Observable<any[]>
  {
    let backendUrlPart='';
    if(activity=='Testing')
    backendUrlPart='/fsw/getMonthWiseTestingStatus/';
    else if(activity=='Trainings')
    backendUrlPart='/fsw/getMonthWiseTrainingStatus/';
    else if(activity=='Awareness Programs')
     backendUrlPart='/fsw/getMonthWiseAwarenessStatus/';
    else if(activity=='Vehicle')
    backendUrlPart='/fsw/getMonthWiseVechileStatus/';
   
    return this.httpClient.get<any[]>(this.apiURL + backendUrlPart+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  
  saveFSWEquipment(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveFSWEquipment', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getEquipmentDDAll(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getAllEquipments')
    .pipe(
      catchError(this.errorHandler)
    )
  }
   saveFSWTestCapability(data:any): Observable<any> {
     return this.httpClient.post<any>(this.apiURL + '/fsw/saveFSWTestCapability', data)
     .pipe(
       catchError(this.errorHandler)
     )
   }
 getFSWParameters(vehicleNo:any, productId:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getFSWTestCapability/' + vehicleNo + '/' + productId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  gettestingcapabilitylist(userId:any){
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getFSWTestCapability/'+ userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getequipmentlist(userId:any){
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getFSWEquipment/'+ userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getfswstatuslist(stateCode:any){
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getFSWStateStatus/'+ stateCode)
  }

  getFSWStatus(stateCode:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getStateWiseCount/'+stateCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  saveFSWStateStatus(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveFSWStateStatus', data)
  }
  getFSWStatusByRegion(regionCode:any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getRegionWiseCount/'+regionCode)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  getFSWManpowerlist(userId:any){
    return this.httpClient.get<any[]>(this.apiURL + '/fsw/getFSWManpower/'+ userId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  saveFSWManpower(data:any): Observable<any> {
    return this.httpClient.post<any>(this.apiURL + '/fsw/saveFSWManpower', data)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  deleteEquipmentId(Id:any) {
    debugger
    return this.httpClient.delete<MainpowerDetails>(this.apiURL + '/fsw/deleteFSWEquipment/' + Id)
    .pipe(
      catchError(this.errorHandler)
    ) 
  }

  getVehicleTokenFromIntangles(data:any): Observable<any> {
    return this.httpClient.post<any>('https://indium-apis.intangles.io/api/v1/vendor/user/new_session', data, this.httpOptions1)
  }
  
   
  errorHandler(error:any) {
    let errorMessage = '';
    if(error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
 }




}
